import React from 'react';
import { useWeather } from '../../context';
import { Select } from '../ui/Select';
import { stormFilters } from '../../constants/parameters';

export function FilterControls() {
  const { 
    modelSelect,
    stormFilter, 
    setStormFilter,
    hailThreshold,
    setHailThreshold
  } = useWeather();

  // Only show for XWeather storm reports
  if (modelSelect !== 'xweather') {
    return null;
  }

  // Store filter changes in local state until fetch
  const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setStormFilter(e.target.value);
  };

  return (
    <div className="mb-6 space-y-4">
      <div>
        <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
          Storm Report Filter
        </label>
        <Select
          value={stormFilter}
          onChange={handleFilterChange}
          options={stormFilters.map(f => ({ value: f.value, label: f.text }))}
        />
      </div>

      {stormFilter === 'hail' && (
        <div>
          <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
            Minimum Hail Size (inches)
          </label>
          <input
            type="number"
            value={hailThreshold}
            onChange={(e) => setHailThreshold(Number(e.target.value))}
            step="0.1"
            min="0"
            className="input w-full"
          />
        </div>
      )}
    </div>
  );
}